// extracted by mini-css-extract-plugin
module.exports = {"answer":"answer--1NCjh"};